import type { ReactNode } from 'react';
import { useEffect } from 'react';
import { ConfigProvider } from 'antd';
import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/zh-cn';

import { useLanguageStore } from '@/store/languageStore';
import { antdLocaleFor, dayjsLocaleFor, installStaticHolder } from './antdLocale';

const TITLES = {
  zh: '底软包交付管理系统',
  en: 'BSP Package Delivery Management',
} as const;

export const LanguageProvider = ({ children }: { children: ReactNode }) => {
  const lang = useLanguageStore((state) => state.lang);

  useEffect(() => {
    installStaticHolder();
  }, []);

  useEffect(() => {
    dayjs.locale(dayjsLocaleFor(lang));
    document.documentElement.lang = lang === 'en' ? 'en' : 'zh-CN';
    document.title = TITLES[lang];
  }, [lang]);

  return <ConfigProvider locale={antdLocaleFor(lang)}>{children}</ConfigProvider>;
};
